import React from 'react';
import '../../styles/table-main/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Research Policies</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Research Policy</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/RESEARCH-POLICY.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Research Opportunities</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Research-Opportunities.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Prevention of Plagiarism</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Prevention-of-Plagiarism.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.Abstract</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <Link to={"/abstract-2021"}>
                                                            {" "}
                                                            Download
                                                        </Link>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Approval of grant under 'Research And Development' Scheme
                                                </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/research-development.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Guidelines of CPCSEA for Experimentation on Fishes</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Guidelines-of-CPCSEA.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Handbook on ICMR Ethical Guidelines</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Handbook_on_ICMR_Ethical_Guidelines.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Standard Operating Procedures (SOP)- CPCSEA</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/SOP_CPCSEA_inner_page.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>National Policy on Academic Ethics</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/national-policy-on-academic-ethics.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            {/* have to add pdf  */}
                                            <tr>
                                                <td>Notices</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Ordinances &amp; Regulations</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Pre PhD Course work</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Supervisors </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Research Projects </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Patents </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Book Published </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Book chapters </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Research awards </td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a href="link" target="_blank" rel="noreferrer">
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;